import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const TwitterShareButton = ({
  imageUrl,
  campaignId,
  reward,
  chances,
  congratsImage,
  tnxId,
  campaignType,
  campaignConfig,
  winAnimations,
}) => {
  const navigate = useNavigate();
  const { tenanturlname } = useParams();

  const openSharingScreen = () => {
    navigate(`/${tenanturlname}/gamification/sharing`, {
      state: {
        reward,
        chances,
        campaignId,
        congratsImage,
        type: "twitter",
        imageUrl,
        tnxId,
        campaignType,
        campaignConfig,
        winAnimations: winAnimations || [],
      },
    });
  };

  return (
    <button
      style={{ border: "none", backgroundColor: "white" }}
      onClick={() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "cta_click",
          ctaName: "social_share_twitter",
          campaignId: String(campaignId),
        });
        openSharingScreen();
      }}
    >
      <img
        src={require("../../../assets/images/icons/twitter-icon.png")}
        alt="Twitter"
        onError={(e) => {
          e.target.style.display = "none";
        }}
      />
    </button>
  );
};

export default TwitterShareButton;
